import { render, staticRenderFns } from "./OfficeStatusReportView.vue?vue&type=template&id=63c9423e&"
import script from "./OfficeStatusReportView.vue?vue&type=script&lang=js&"
export * from "./OfficeStatusReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports